import { render } from "./SwitchinCaricati.vue?vue&type=template&id=48507e91&scoped=true"
import script from "./SwitchinCaricati.vue?vue&type=script&lang=js"
export * from "./SwitchinCaricati.vue?vue&type=script&lang=js"

import "./SwitchinCaricati.vue?vue&type=style&index=0&id=48507e91&lang=css"
import "./SwitchinCaricati.vue?vue&type=style&index=1&id=48507e91&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48507e91"]])

export default __exports__